import React from "react";
import estilo from "../styles/Tarjeta.module.css";
import { Link } from "react-router-dom";

function Tarjeta({ pelicula }) {
  return (
    // <Link to={"/pelicula/" + pelicula.id}>
    <Link
      to={
        pelicula.tipo === "pelicula"
          ? "/pelicula/" + pelicula.id
          : "/serie/" + pelicula.id
      }
    >
      <div className={estilo.tarjeta}>
        <div className={estilo.portada}>
          <img src={pelicula.portada} alt={pelicula.titulo} />
        </div>
        <h2>{pelicula.titulo}</h2>
      </div>
    </Link>
  );
}

export default Tarjeta;
